<script lang="ts" setup>
import { useRuntimeConfig } from 'nuxt/app';
import facebookNegativeIcon from '~/assets/images/icons/facebook-negative.svg';
import facebookIcon from '~/assets/images/icons/facebook.svg';
import instagramNegativeIcon from '~/assets/images/icons/instagram-negative.svg';
import instagramIcon from '~/assets/images/icons/instagram.svg';
import linkedinNegativeIcon from '~/assets/images/icons/linkedin-negative.svg';
import linkedinIcon from '~/assets/images/icons/linkedin.svg';
import twitterIcon from '~/assets/images/icons/twitter.svg';
import xNegativeIcon from '~/assets/images/icons/x-negative.svg';

// `negative` swaps in the white-on-dark icon set (the Figma "Negative"
// variant) for the dark footer; the default set is drawn for light
// backgrounds, e.g. LandingFooter.
const { variant = 'default' } = defineProps<{
  variant?: 'default' | 'negative';
}>();

const config = useRuntimeConfig();

const isNegative = computed(() => variant === 'negative');

// The URLs are deployment config (FACEBOOK_LINK / TWITTER_LINK /
// INSTAGRAM_LINK / LINKEDIN_LINK). Leaving a var blank or unset hides that
// platform entirely.
const socialMedias = computed(
  (): { icon: string; label: string; link: string }[] =>
    [
      {
        icon: isNegative.value ? facebookNegativeIcon : facebookIcon,
        label: 'Facebook',
        link: config.public.facebookLink,
      },
      {
        icon: isNegative.value ? xNegativeIcon : twitterIcon,
        label: 'X',
        link: config.public.twitterLink,
      },
      {
        icon: isNegative.value ? instagramNegativeIcon : instagramIcon,
        label: 'Instagram',
        link: config.public.instagramLink,
      },
      {
        icon: isNegative.value ? linkedinNegativeIcon : linkedinIcon,
        label: 'LinkedIn',
        link: config.public.linkedinLink,
      },
    ].filter((socialMedia) => !!socialMedia.link?.trim()),
);
</script>

<template>
  <div class="social-media-list flex items-center gap-6">
    <a
      v-for="socialMedia in socialMedias"
      :key="socialMedia.label"
      :href="socialMedia.link"
      :target="socialMedia.link === '#' ? undefined : '_blank'"
      :rel="socialMedia.link === '#' ? undefined : 'noopener noreferrer'"
      :aria-label="`VoteWise on ${socialMedia.label}`"
      class="social-media-list__link"
    >
      <img
        :src="socialMedia.icon"
        :alt="socialMedia.label"
        width="24"
        height="24"
      />
    </a>
  </div>
</template>

<style lang="scss" scoped>
.social-media-list {
  &__link {
    display: inline-flex;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
